// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivatePage_container__uSf_7","loader":"PrivatePage_loader__rUI_W","spin":"PrivatePage_spin__zCls8"};